import { Koi } from '@ksyos/koi';
import { YesOrNoOrStoppedOrUnknown } from '../../../common/enums/YesOrNoOrStopped';
import { getTextAreaStringSchema } from '../utils/getTextAreaStringSchema';
import {
    alcoholDaysPerWeekSchema,
    alcoholGlassesPerDagSchema,
    lengthInCmSchema,
    smokingPacksADaySchema,
    smokingYearsSchema,
    weightInKgSchema,
} from './numberSchemas';

const questionnaireSchema = Koi.object({
    answers: Koi.object(),
});

export function getQuestionnaireSchema(min: number, max: number) {
    return {
        schema: questionnaireSchema
            .keys({
                answers: Koi.object().required().max(max).min(min),
            })
            .required(),
    };
}

export type IOsasLifeStyleFormCustomControlData = {
    alcoholStoppedSince: string | null;
    daysAWeek: number | null;
    drugUseStoppedSince: string | null;
    glassesADay: number | null;
    isAlcoholUser: YesOrNoOrStoppedOrUnknown | null;
    isDrugUser: YesOrNoOrStoppedOrUnknown | null;
    isDrugUserRemark: string | null;
    isSmoker: YesOrNoOrStoppedOrUnknown | null;
    isSmokerRemark: string | null;
    lengthInCm: number | null;
    packsADaySmoked: number | null;
    page?: number;
    smokingStoppedSince: string | null;
    weightInKg: number | null;
    yearsSmoked: number | null;
};

export type IOsasLifeStyleFormCustomControlDataWithPage = IOsasLifeStyleFormCustomControlData & {
    page: number;
};

const alcoholFields = {
    alcoholStoppedSince: getTextAreaStringSchema(true, 255),
    daysAWeek: alcoholDaysPerWeekSchema.allow(null),
    glassesADay: alcoholGlassesPerDagSchema.allow(null),
    isAlcoholUser: Koi.koi().enum(YesOrNoOrStoppedOrUnknown).allow(null),
};

const drugUseFields = {
    drugUseStoppedSince: getTextAreaStringSchema(true, 255),
    isDrugUser: Koi.koi().enum(YesOrNoOrStoppedOrUnknown).allow(null),
    isDrugUserRemark: getTextAreaStringSchema(true),
};

const smokingFields = {
    isSmoker: Koi.koi().enum(YesOrNoOrStoppedOrUnknown).allow(null),
    isSmokerRemark: getTextAreaStringSchema(true),
    packsADaySmoked: smokingPacksADaySchema.allow(null),
    smokingStoppedSince: getTextAreaStringSchema(true, 255),
    yearsSmoked: smokingYearsSchema.allow(null),
};

const bmiFields = {
    lengthInCm: lengthInCmSchema.allow(null),
    weightInKg: weightInKgSchema.allow(null),
};

export const lifestyleQuestionnaireDraftSchema = Koi.object({
    ...alcoholFields,
    ...drugUseFields,
    ...smokingFields,
    ...bmiFields,
    page: Koi.number().min(0).max(4).required(),
});

export const lifestyleQuestionnaireFinalSchema = Koi.object({
    ...alcoholFields,
    ...drugUseFields,
    ...smokingFields,
    ...bmiFields,
});
